import {
  giftcardDesignPreviewImage,
  useSelector
} from '../../imports/generalImport';
import {
  Box,
  Typography
} from '../../imports/muiImport';

const GiftCardDesignPreview = () => {
  const { selectedPost } = useSelector((state) => state.GiftCardDesign);

  return (
    <Box
      sx={{
        position: 'relative',
        width: '100%',
        maxWidth: {
          xs: 200,   // Mobile
          sm: 250,   // Small tablets
          md: 300,   // Tablets and small laptops
          lg: 350    // Large screens
        },
        height: {
          xs: 'calc(200 * 16/9)px',  // Maintain aspect ratio
          sm: 460,
          md: 600
        },
        margin: '0 auto',
        aspectRatio: '9/16',
        backgroundImage: `url(${giftcardDesignPreviewImage})`,
        backgroundSize: 'cover',
        backgroundRepeat: 'no-repeat',
        backgroundPosition: 'center',
        overflow: 'auto',
      }}
    >
      <Box
        id="giftCardPreview"
        sx={{
          position: 'absolute',
          top: {
            xs: '10%',  // Slightly less padding on mobile
            sm: '12%'   // Original padding on larger screens
          },
          left: {
            xs: '8%',
            sm: '10%'
          },
          right: {
            xs: '8%',
            sm: '10%'
          },
          bottom: {
            xs: '10%',
            sm: '12%'
          },
          display: 'flex',
          alignItems: 'flex-start',
          justifyContent: 'center',
          textAlign: 'center',
          px: {
            xs: 2,  // Less padding on mobile
            sm: 3   // Original padding on larger screens
          },
          overflow: 'hidden',
          borderRadius: 2,
        }}
      >
        {selectedPost?.image ? (
          <Box
            component="img"
            src={selectedPost.image}
            alt={selectedPost.altText || 'Selected gift card design'}
            sx={{
              maxWidth: '100%',
              maxHeight: '100%',
              objectFit: 'contain',
              borderRadius: 2,
              boxShadow: 3,
            }}
          />
        ) : (
          <Typography
            variant="body2"
            color="text.secondary"
            sx={{
              fontSize: {
                xs: '0.75rem',  // Smaller text on mobile
                sm: '0.875rem'   // Standard size on larger screens
              }
            }}
          >
            No design selected
          </Typography>
        )}
      </Box>
    </Box>
  );
};

export default GiftCardDesignPreview;